<template>
<div class="orderDetail">
  <div class="orderDetail-top">
    <div class="iconfont iconzuojiantou jian" @click="goBack"></div>
    <div>工单详情</div>
    <div></div>
  </div>
  <!-- 头部背景图片 -->
  <div class="detail-back-img" v-if="orderList.workloadStatusNew===1">未确认</div>
  <div class="detail-back-img" v-if="orderList.workloadStatusNew===2">拒绝确认</div>
  <div class="detail-back-img" v-if="orderList.workloadStatusNew===3">待结算</div>
  <div class="detail-back-img" v-if="orderList.workloadStatusNew===4">已关闭</div>
  <div class="detail-back-img" v-if="orderList.workloadStatusNew===5">已结算</div>
  <div class="detail-back-img" v-if="orderList.workloadStatusNew===6">不可结算</div>
  <div class="detail-back-img" v-if="orderList.workloadStatusNew===7">待打款</div>
  <!-- 步骤条 -->
  <div class="detail-step">
    <div class="step-left">
      <div class="bohui" v-if="tabId==1"><img :src="daiqueren" alt=""></div>
      <div class="bohui" v-if="tabId==2"><img :src="duigou" alt=""></div>
      <div class="bohui" v-if="tabId==3"><img :src="bohui" alt=""></div>
      <div class="dotted"></div>
      <div class="duigou"><img :src="duigou" alt=""></div>

    </div>
    <div class="step-right">
      <div class="company-mess">
        <div class="company">{{orderList.platformTaskRes.companyName}}</div>
        <div>{{orderList.confirmAt}}</div>
      </div>
      <div class="user-mess">
        <div class="name">{{orderList.userName}}</div>
        <div>{{orderList.createdAt}}</div>
      </div>
    </div>
  </div>
  <!-- 任务信息 -->
  <div class="detail-all">
    <div class="detail-task">
    <div class="task-message">
      <div class="twig"></div>
      <div>任务信息</div>
    </div>
    <div class="basic-serve">{{orderList.platformTaskRes.taskName}}</div>
    <div class="city-num" v-for="item in orderList.platformTaskRes.pTCityPlatformTaskDTO" :key="item.areaId">
      <div class="city">{{item.areaName}}</div>
      <div class="city-twig"></div>
      <div class="num">{{
                orderList.platformTaskRes.peopleNumber == -1
                  ? "人数不限"
                  : orderList.platformTaskRes.peopleNumber + "人"
              }}</div>
    </div>
    <div class="city-num">
      <div class="city">{{eduMap[orderList.platformTaskRes.requirementEducation]}}</div>
      <div class="city-twig"></div>
      <div class="num">{{ genderMap[orderList.platformTaskRes.requirementSex] }}</div>
      <div class="city-twig"></div>
      <div>{{orderList.platformTaskRes.requirementAgeMin}}--{{orderList.platformTaskRes.requirementAgeMax}}周岁</div>
    </div>
    <div class="company-name">{{orderList.platformTaskRes.companyName}}</div>
  </div>
  <div class="salary">
    <span v-if="orderList.platformTaskRes.salaryAsk == 'SECTION'">
                {{ orderList.platformTaskRes.salaryBlockMin }}-{{ orderList.platformTaskRes.salaryBlockMax }}元 /
                {{ orderList.platformTaskRes.salaryUnit }}
              </span>
              <span v-if="orderList.platformTaskRes.salaryAsk == 'DISCUSS'"> 面议 </span>
              <span v-if="!orderList.platformTaskRes.salaryAsk || orderList.platformTaskRes.salaryAsk == 'FIXED'">
                  {{ orderList.platformTaskRes.salarySettlement }}元/{{ orderList.platformTaskRes.salaryUnit }}
              </span>
  </div>
  </div>
  <!-- 工单信息 -->
  <div class="detail-order">
    <div class="order-message">
      <div class="order-twig"></div>
      <div>工单信息</div>
    </div>
    <div class="serve-time">
      <span>服务时间：</span><span class="serve-mes">{{orderList.beginTimeStr}}--{{orderList.endTimeStr}}</span>
    </div>
    <div class="serve-no">
      <span>服务数量：</span><span class="serve-mes">{{orderList.salaryQuantity}}天</span>
    </div>
    <div class="serve-content"><span>服务内容：</span><span class="serve-mes">{{orderList.content}}</span></div>
  </div>
</div>
  
</template>
<script>
// import { config } from 'vue/types/umd';
import http from "../../../api/index.js";
import config from "../../../utils/config";
import dayjs from 'dayjs';
export default {
  data(){
    return{
      formData:{
        id:null,
      },
      orderList:{},
      eduMap: {
        10:"学历不限",
        20:"初中",
        30:"高中",
        40:"专科",
        50:"本科",
        60:"硕士",
        70:"博士"  
      },
      tabId:"",
      beginTimeStr:"",
      endTimeStr:"",
      currentPage:"",
      genderMap: {
        male: "男",
        female: "女",
        unlimited: "不限"
      },
      duigou:require("../../../assets/img/duigou.png"),
      bohui:require("../../../assets/img/bohui.png"),
      daiqueren:require("../../../assets/img/daiqueren.png"),    
    }
  },
  mounted(){
    const url = new URL(location.href);
    this.formData.id = url.searchParams.get('id');
    this.tabId=url.searchParams.get('tabId');
    this.currentPage=url.searchParams.get('currentPage');
    console.log(this.formData.id)
    this.workloadInfo()
  },
  methods:{
    goBack(){
      this.$router.push({path:"/workOrderTab",query:{tabId:this.tabId,currentPage:this.currentPage}})
    },
    workloadInfo(){
      http.post(config.workloadInfo,this.formData).then(({code,data,message})=>{
        this.orderList=data; 
        this.orderList.beginTimeStr = this.orderList.platformTaskRes.workTimeBegin ? dayjs(this.orderList.platformTaskRes.workTimeBegin).format("YYYY-MM-DD") : '' ;
        this.orderList.endTimeStr = this.orderList.platformTaskRes.workTimeEnd ? dayjs(this.orderList.platformTaskRes.workTimeEnd).format("YYYY-MM-DD") : '' ;  
      })
    }
  }

}
</script>
<style lang="less" scoped>
.orderDetail{
  text-align: left;
  height: 100%;
  background: #F8F8FA;
  .orderDetail-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    font-size: 35px;
    .jian{
      font-size: 35px;
    }
  }
  .detail-back-img{
    width: 100%;
    height: 160px;
    background: url("../../../assets/img/waitsure.png") no-repeat;
    background-size: contain;
    text-align: left;
    line-height: 160px;
    padding-left: 40px;
    box-sizing: border-box;
    color: #000000;
  }
  // 步骤条
  .detail-step{
    display: flex;
    align-items: center;
    background: #ffffff;
    margin-bottom: 30px;
    padding: 20px 0;
    .step-left{
      padding-left: 30px;
      .duigou{
        padding-left: 10px;
        img{
          width: 25px;
          height: auto;
        }
      }
      .bohui{
        padding-left: 10px;
        // margin-top: 8px;
        img{
          width: 25px;
          height: auto;
        }
      }
      .dotted{
        height: 40px;
        border-left:3px dotted #888888;
        margin: 5px 0 10px 20px;
      }

    }
    .step-right{
      margin-left: 30px;
      color: #888888;
      .company-mess{
        margin-bottom: 30px;
        .company{
          font-size: 26px;
        }
      }
      .user-mess{
        .name{
          font-size: 26px;
        }


      }

    }

  }
  .detail-all{
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    align-items: center;
    .detail-task{
    padding: 30px;
    margin-top: 30px;
    .task-message{
      display: flex;
      align-items: center;
      font-size: 30px;
      .twig{
        width: 4px;
        height: 28px;
        background: #1e9def;
        margin-right: 10px;
      }
    }
    .basic-serve{
      padding: 0 30px;
      margin: 8px 0;
      font-size: 27px;
    }
    .city-num{
      padding: 0 30px;
      display: flex;
      align-items: center;
      margin: 8px 0;
      font-size: 27px;
      .city-twig{
         height: 25px;
         width: 1px;
         background: #000;
         margin: 0 10px;
      }
    }
    .company-name{
      padding: 0 30px;
      font-size: 27px;
      color: #808080;
    }
  }
  .salary{
    padding-right: 30px;
    font-size: 30px;
    color: red;
  }

  }
  .detail-order{
    padding: 20px;
    margin-top: 30px;
    background: #ffffff;
    .order-message{
      display: flex;
      align-items: center;
      font-size: 30px;
      .order-twig{
        width: 4px;
        height: 28px;
        background: #1e9def;
        margin-right: 10px;
      }
    }
    .serve-time{
      padding: 0 30px;
      margin: 8px 0;
      font-size: 28px;
      .serve-mes{
        color: #808080;
      }
    }
    .serve-no{
      padding: 0 30px;
      font-size: 28px;
      .serve-mes{
        color: #808080;
      }

    }
    .serve-content{
      padding: 0 30px;
      font-size: 28px;
      .serve-mes{
        color: #808080;
      }
      
    }

  }
}

</style>


// WEBPACK FOOTER //
// src/pages/workOrder/workOrderDetail/index.vue